import { SegmentationType } from "../types";

export const segmentationOrder: Record<SegmentationType, number> = {
  Awareness: 0,
  Interest: 1,
  Decision: 2,
};
